import React, { useState } from 'react';
import { GameFilters } from '../../shared/interfaces';


interface FilterDropdowndProps {
  hidden?: boolean; 
  gameType: string;
  applyFiltersToGameList: (filters: GameFilters) => void;
  /** When false, hides the Modified On date range filter. Default true. */
  showModifiedOn?: boolean;
}

const GameFilterDropdown: React.FC<FilterDropdowndProps> = ({applyFiltersToGameList, gameType, showModifiedOn = true}) => {
  const [filters, setFilters] = useState<GameFilters>({ teamA: '', teamB: '', teamC: '', overs: '', modifiedOnStart: '', modifiedOnEnd: '' });

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => {
      if (name === "modifiedOnEnd" && prevFilters.modifiedOnStart && value) {
        if (value < prevFilters.modifiedOnStart) {
          window.dispatchEvent(new CustomEvent('show-toast', { detail: { message: 'End date cannot be earlier than start date.', type: 'error' } }));
          return prevFilters;
        }
      }
      if (name === "modifiedOnStart" && prevFilters.modifiedOnEnd && value) {
        if (prevFilters.modifiedOnEnd < value) {
          window.dispatchEvent(new CustomEvent('show-toast', { detail: { message: 'End date cannot be earlier than start date.', type: 'error' } }));
          return prevFilters;
        }
      }

      return {
        ...prevFilters,
        [name]: value,
      };
    });
  };

  const applyFilters = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (e.currentTarget.textContent === 'Clear') {
      const clearedFilters = showModifiedOn 
        ? { teamA: '', teamB: '', teamC: '', overs: '', modifiedOnStart: '', modifiedOnEnd: '' }
        : { teamA: '', teamB: '', teamC: '', overs: '' };
      setFilters(clearedFilters);
      
      setTimeout(() => {
        applyFiltersToGameList(clearedFilters);
      }, 0);
      return;
    }

    if (showModifiedOn && ((filters.modifiedOnStart && !filters.modifiedOnEnd) || (!filters.modifiedOnStart && filters.modifiedOnEnd))) {
      window.dispatchEvent(new CustomEvent('show-toast', { detail: { message: 'End date cannot be earlier than start date.', type: 'error' } }));
      return;
    }

    const filtersToApply = showModifiedOn ? filters : { teamA: filters.teamA, teamB: filters.teamB, teamC: filters.teamC, overs: filters.overs };
    applyFiltersToGameList(filtersToApply);
  };

  return (
    <div className="w-full mb-4 flex items-center space-x-4 bg-gray-50 p-0 rounded-b-sm border m-0">
      <label className="text-sm font-medium text-gray-700 flex flex-row items-center space-x-2">
        <span>Nation A</span>
        <input
          type="text"
          name="teamA"
          value={filters.teamA}
          onChange={handleFilterChange}
          className="w-40 p-1 border rounded"
        />
      </label>
      <label hidden={gameType === 'session'} className="text-sm font-medium text-gray-700 flex flex-row items-center space-x-2">
        <span>Nation B</span>
        <input
          type="text"
          name="teamB"
          value={filters.teamB}
          onChange={handleFilterChange}
          className="w-40 mt-1 p-1 border rounded"
        />
      </label>
      <label hidden={gameType !== 'session'} className="text-sm font-medium text-gray-700 flex flex-row items-center space-x-2">
        <span>Overs</span>
        <input
          type="number"
          name="overs"
          value={filters.overs}
          onChange={handleFilterChange}
          className="w-40 mt-1 p-1 border rounded"
        />
      </label>
      {showModifiedOn && (
        <label className="text-sm font-medium text-gray-700 flex flex-row items-center space-x-2">
          <span>Modified On</span>
          <input
            type="date"
            value={filters.modifiedOnStart || ''}
            name="modifiedOnStart"
            onChange={handleFilterChange}
            className="w-32 mt-1 p-1 border rounded"
            placeholder="Start date"
          />
          <span>to</span>
          <input
            type="date"
            value={filters.modifiedOnEnd || ''}
            name="modifiedOnEnd"
            onChange={handleFilterChange}
            className="w-32 mt-1 p-1 border rounded"
            placeholder="End date"
          />
        </label>
      )}
      <div className="flex-1 flex justify-end">
        <button
          onClick={applyFilters}
          className="px-4 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Apply
        </button>
        <button
          onClick={applyFilters}
          className="px-4 py-1 ml-1 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default GameFilterDropdown;


